const Cliente = {
    apellido: '',
    email: '',
    nombre: '',
    numeroDocumento: '',
    telefonoCelular: '',
    telefonoInterno: null,
    tipoDocumento: '',
    planElegido: null,
    mailOfuscado: '',
    terminos: '',
    comboElegido: null,
    crmId: '',
    fechaNacimiento: '',
    telefonoDirecto: null,
    telefonoLaboral: null,
    telefonoParticular: null,
    domicilios: [],
    selector_residencia: '',
    planId: '',
    residencia: '',
};

export default Cliente;
